import { FirstLoginCard } from "@/features/session/components/FirstLoginCard";
import { TUserFirstLoginState } from "@/features/session/types/userFirstLoginState";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";

const UserFirstLoginPage = () => {
  const { state } = useLocation();

  const { organizationId, userRegistrationToken, productCode, purposes, otherText } = (state as TUserFirstLoginState | null) ?? {};

  if (!userRegistrationToken) {
    return <Navigate to={AppRoutes.organizationSelect} replace />;
  }

  return (
    <Stack alignItems="center">
      <FirstLoginCard
        organizationId={organizationId}
        productCode={productCode}
        userRegistrationToken={userRegistrationToken}
        purposes={purposes}
        otherText={otherText}
        sx={{ width: "100%", maxWidth: 660 }}
      />
    </Stack>
  );
};

export default UserFirstLoginPage;
